/// <amd-module name="Widgets/IframeWidget/IframeWidget" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { isSameOrigin } from "VSS/Platform/Util/Url";
import * as WidgetTelemetry from "Dashboards/WidgetCommon/WidgetTelemetry";
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import { UnconfiguredMessage } from "Reporting/Visuals/VisualMessages/UnconfiguredMessage";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import * as Resources from "Widgets/IframeWidget/Resources";
interface IframeWidgetSettings {
    url: string;
}

export class IframeWidget extends VssComponent<WidgetProps, { isBarVisible: boolean }> {
    constructor(props: WidgetProps, context: IVssComponentContext) {
        super(props);
        this.state = {
            isBarVisible: true,
        };
    }
 
    public componentDidMount() {
        this.props.onWidgetLoaded();
        WidgetTelemetry.onWidgetLoaded(this.context.pageContext, this.props);
    }
 
    private hideBar = () => {
        // Update the state to hide the bar
        this.setState({
            isBarVisible: false,
        });
    };
 
    public render(): JSX.Element {
        const { isBarVisible } = this.state;
       
        if (!this.props.settings) {
            return <UnconfiguredMessage visualTitle={this.props.name} size={this.props.size} onClick={this.props.onConfigure} />;
        } else {
            if (this.isValidProtocol()) {
                return (
                    <div className={"iframe-widget-container"}>
                        {isBarVisible &&
                            <div className="transparent-bar">
                                <div className="close-button" onClick={this.hideBar}>
                                    &times;
                                </div>
                                <p className="message">{Resources.InfoMessage}</p>
                            </div>
                        }
                        <iframe
                            title="Embedded webpage widget"
                            frameBorder={0}
                            allowFullScreen={true}
                            sandbox={`allow-scripts ${this.shouldAllowSameOrigin() ? "allow-same-origin" : ""} ${this.isTrustedUrlToAllowPopsups() ? "allow-popups allow-popups-to-escape-sandbox" : ""}`}
                            scrolling={"no"}
                            width={this.props.size.width}
                            height={this.props.size.height}
                            src={this.parseSettings()}
                        />
                    </div>
                );
            } else {
                throw Error(Resources.UrlNoProtocolError);
            }
        }
    }

    private parseSettings(): string {
        if (this.props.settings) {
            return (JSON.parse(this.props.settings) as IframeWidgetSettings).url;
        }
        return "";
    }

    /**
     *  Prevent same-origin framed content from accessing the parent frame in onPrem scenarios.
     *  In hosted, allow calls to be made to the embedded iframe origin for content.
     */
    private shouldAllowSameOrigin(): boolean {
        const isSameOriginContent = isSameOrigin(this.parseSettings(), window.location.href);
        const isHosted = TfsWidgetContext.isHosted(this.context.pageContext);
        return isHosted || !isSameOriginContent;
    }

    private isTrustedUrlToAllowPopsups(): boolean {
       let host = new URL(this.parseSettings()) ? new URL(this.parseSettings()).origin : "";
       return /^https:\/\/[a-z0-9-]*\.powerbi.com$/i.test(host);
    }

    private isValidProtocol(): boolean {
        return /^https?:\/\//.test(this.parseSettings());
    }
}

VssComponent.register("iframeWidget", IframeWidget);